import '../../scss/components/_product-line-slider.scss';
import '../../scss/components/_product-line-slide.scss';

export class ProductLineSlider {
    constructor (target) {
      this.section = target;
    }

    async init () {
      if (!this.section || CMS.editMode) {
        return;
      }

      const { default: Swiper } = await import('swiper');
      const { Navigation } = await import('swiper/modules');

      await import('swiper/css');
      await import('swiper/css/navigation');

      const config = {
        slidesPerView: 1,
        enabled: true,
        a11y: {
          slideRole: 'presentation',
          slideLabelMessage: '',
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
        },
        navigation: {
          nextEl: this.section.querySelector('.swiper-button-next'),
          prevEl: this.section.querySelector('.swiper-button-prev'),
        },
        modules: [Navigation],
      };

      const sliderElement = this.section.querySelector('.swiper')

      new Swiper(sliderElement, config);
        this.loading(false);
    }

    loading(isLoading = true) {
        this.section.classList.toggle('loading', isLoading);
    }
}
